import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import AllPoolsTable from "./AllPoolsTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const AllPools = ({ isAdmin }) => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    pools: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Pools/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          pools: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <AllPoolsTable
            data={dataObj.pools}
            title={"All Pools"}
            isAdmin={isAdmin}
          />
        </div>
      )}
    </>
  );
};
export default AllPools;
